// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/availability_metadata.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_availability_window } from "./availability_window_pb";

/**
 * Describes the file proto/model/core/availability_metadata.proto.
 */
export const file_proto_model_core_availability_metadata = /*@__PURE__*/
  fileDesc("Cixwcm90by9tb2RlbC9jb3JlL2F2YWlsYWJpbGl0eV9tZXRhZGF0YS5wcm90bxIGY2FybWVuIqgCChRBdmFpbGFiaWxpdHlNZXRhZGF0YRI4ChRhdmFpbGFiaWxpdHlfd2luZG93cxgBIAMoCzIaLmNhcm1lbi5BdmFpbGFiaWxpdHlXaW5kb3cSMAoMbGFzdF9jaGVja2VkGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIyCg92YWxpZGl0eV9wZXJpb2QYAyABKAsyGS5nb29nbGUucHJvdG9idWYuRHVyYXRpb24SFwoPaG9sZHNfYXZhaWxhYmxlGAQgASgIEjQKEW1heF9ob2xkX2R1cmF0aW9uGAUgASgLMhkuZ29vZ2xlLnByb3RvYnVmLkR1cmF0aW9uEiEKGWluc3RhbnRfYm9va2luZ19hdmFpbGFibGUYBiABKAhCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw", [file_google_protobuf_duration, file_google_protobuf_timestamp, file_proto_model_core_availability_window]);

/**
 * Describes the message carmen.AvailabilityMetadata.
 * Use `create(AvailabilityMetadataSchema)` to create a new message.
 */
export const AvailabilityMetadataSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_availability_metadata, 0);

